import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    container: {
        height: '100%',
        maxHeight: '100%',
        overflow: 'auto',
    },
    searchInput: {
        width: '400px',
        backgroundColor: '#f7f7f7',
        borderRadius: 5,
        paddingTop: 1, // Add top and bottom padding since we remove the border
        paddingBottom: 1,
        '& fieldset': {
            border: 'none',
        },
    },
    navigationChips: {
        display: 'flex',
        marginTop: 22,
        marginBottom: 50,
    },
    navigationChip: {
        marginRight: 10,
        padding: '0 30px',
        color: '#3e4555',
        fontSize: 12,
        fontWeight: 500,
        fontFamily: 'Gotham',
        '&.selected': {
            backgroundColor: '#535a6b',
            color: '#fff',
        },
    },
}));
